import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './LinkTalentPage.module.css';
import { isArrayLength } from '../../util/genericHelpers';
import { useDispatch, useSelector } from 'react-redux';
import {
  removeTalent,
  removeTalentInProgressSelector,
  selectedTalentIdSelector,
} from './LinkTalentPage.duck';
import { Button, IconSpinner, NamedLink } from '../../components';
import { LinkTalentTabs } from '../../util/enums';
import { createResourceLocatorString } from '../../util/routes';

const LinkedTalentsTable = ({
  associatedUsers,
  currentUserListing,
  routeConfiguration,
  history,
  listingTitle,
}) => {
  // Fallback if associatedUsers is not an array or empty
  if (!isArrayLength(associatedUsers)) {
    const redirectToLinkTalentPage = () => {
      history.push(
        createResourceLocatorString(
          'LinkTalentPage',
          routeConfiguration,
          { tab: LinkTalentTabs.LINK },
          {}
        )
      );
    };
    return (
      <p className={css.noTalents}>
        <FormattedMessage
          id="LinkedTalentsTable.noTalents"
          defaultMessage="No linked talents found."
        />{' '}
        <Button className={css.linkTalentButton} type="button" onClick={redirectToLinkTalentPage}>
          <FormattedMessage
            id="LinkedTalentsTable.clickHereToLinkTalent"
            defaultMessage="Click Here to Link Talent"
          />
        </Button>{' '}
      </p>
    );
  }
  const listingId = currentUserListing?.id?.uuid || null;
  const dispatch = useDispatch();
  const selectedTalentId = useSelector(selectedTalentIdSelector);
  const removeTalentInProgress = useSelector(removeTalentInProgressSelector);
  const removeTalentHandler = talentId => {
    if (removeTalentInProgress) return;
    dispatch(removeTalent({ listingId, talentId }));
  };
  return (
    <div className={css.tableContainer}>
      <h3 className={css.panelHeading}>
        <FormattedMessage
          id="LinkedTalentsTable.heading"
          defaultMessage="Current Linked Talents"
          values={{ listingTitle }}
        />
      </h3>
      <table className={css.table}>
        <thead>
          <tr>
            <th className={css.tableHeader}>
              <FormattedMessage id="LinkedTalentsTable.email" defaultMessage="Email" />
            </th>
            <th className={css.tableHeader}>
              <FormattedMessage id="LinkedTalentsTable.talentId" defaultMessage="Talent ID" />
            </th>
            <th className={css.tableHeader}>
              <FormattedMessage
                id="LinkedTalentsTable.removeTalent"
                defaultMessage="Remove Talent"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {associatedUsers.map((user, index) => (
            <tr key={index} className={css.tableRow}>
              <td className={css.tableCell} data-label="Email">
                {user.email}
              </td>
              <td className={css.tableCell} data-label="Talent ID">
                {user.talentId}
              </td>
              <td className={css.tableCell} data-label="Remove Talent">
                {selectedTalentId === user.talentId ? (
                  <IconSpinner />
                ) : (
                  <span
                    className={css.removeCell}
                    onClick={() => removeTalentHandler(user.talentId)}
                  >
                    {' '}
                    <FormattedMessage id="LinkedTalentsTable.remove" defaultMessage="Remove" />
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <NamedLink
        className={css.talentLink}
        name="LinkTalentPage"
        params={{ tab: LinkTalentTabs.LINK }}
      >
        <FormattedMessage id="LinkedTalentsTable.linkTalents" defaultMessage="Link talents" />
      </NamedLink>
    </div>
  );
};

export default LinkedTalentsTable;
